import { Link } from 'react-router-dom';
import { Repeat } from 'lucide-react';
import {
  APPOINTMENT_STATUS,
  Badge,
  Card,
  formatMoney,
  formatRelativeDay,
  formatTime,
  useTenant,
} from '@barber/ui';
import type { Appointment } from '@barber/ui';
import { appointmentTotalCents, serviceLabel } from '@barber/shared';

/** Um horário na lista. */
export function AppointmentCard({
  appointment,
  compact = false,
}: {
  appointment: Appointment;
  compact?: boolean;
}) {
  const { locale } = useTenant();
  const status = APPOINTMENT_STATUS[appointment.status];
  const precoFinal = appointmentTotalCents(appointment);

  return (
    <Card as="li" className="list-none">
      <Link to={`/horarios/${appointment.id}`} className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs uppercase tracking-wide text-content-muted">
            {formatRelativeDay(appointment.startsAt, locale)} ·{' '}
            {formatTime(appointment.startsAt, locale)}
          </p>

          <p className="mt-1 truncate font-semibold text-content">
            {serviceLabel(
              appointment.service.name,
              (appointment.addOns ?? []).map((a) => a.service),
            )}
          </p>
          <p className="truncate text-sm text-content-muted">com {appointment.barber.name}</p>

          {appointment.recurrenceId && (
            <p className="mt-1 flex items-center gap-1 text-xs text-content-muted">
              <Repeat className="h-3 w-3" aria-hidden="true" />
              Horário fixo
            </p>
          )}

          {appointment.groupId && (
            <p className="mt-1 text-xs text-content-muted">Em sequência com outro serviço</p>
          )}

          {!compact && (
            <p className="mt-2 text-sm text-content">
              {precoFinal === 0 ? (
                <span className="font-semibold text-sx-success">Incluso no plano</span>
              ) : (
                <>
                  {formatMoney(precoFinal, locale)}
                  {appointment.discountCents > 0 && (
                    // O "de" é o total sem o desconto: o encaixe nunca tem
                    // desconto, então ele entra dos dois lados da comparação.
                    <span className="ml-2 text-content-muted line-through">
                      {formatMoney(appointment.priceCents + (appointment.addOnsCents ?? 0), locale)}
                    </span>
                  )}
                </>
              )}
            </p>
          )}
        </div>

        <Badge tone={status.tone}>{status.label}</Badge>
      </Link>
    </Card>
  );
}
